<template>
  <div>
    <div class="flex flex-col gap-3 items-center justify-center">
      <select v-model="selectedMonth" class="text-xs appearance-none bg-white rounded-3xl border-none text-pink-900 py-2 px-3 outline-none w-1/2">
        <option value="" selected="selected">Selecione um Período</option>
        <option v-for="(label, value) in filterableMonths" :key="value" :value="value">{{ label }}</option>
      </select>

      <p class="text-white text-center text-lg">Embaixador, aqui estão suas metas como Supervisor:</p>
    </div>
    <div class="flex gap-8 sm:flex-col md:flex-col">
        <GoalCard v-for="(score, index) in scores" :key="index" :goals="score.goals" class="w-full">
            {{ score.name }}
        </GoalCard>
    </div>
  </div>
</template>

<script>
import GoalCard from '@/Components/GoalCard.vue'

export default {
    components: {
        GoalCard
    },
    props: {
        filterableMonths: {
            type: Object,
            default: [],
        },
        scores: {
            type: Array,
            default: [],
        }
    },
    data(){
        return {
            selectedMonth: ''
        }
    }
};
</script>